// extracted by mini-css-extract-plugin
module.exports = {"requestsBoxWrapper":"SubheaderParlour_requestsBoxWrapper__1qGsq","requestsBox":"SubheaderParlour_requestsBox__3NFke"};